import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSecureAuth } from "@/hooks/useSecureAuth";
import { fetchCreditBalance, fetchPaidCreditBalance } from "../api/fetchers";
import { dashboardKeys } from "../api/keys";

export function useCreditBalance() {
  const { user } = useSecureAuth();

  return useQuery({
    queryKey: dashboardKeys.creditBalance(user?.id ?? ""),
    queryFn: () => fetchCreditBalance(user!.id),
    enabled: !!user,
  });
}

/** Paid-only balance: what a preview unlock can be charged against. */
export function usePaidCreditBalance() {
  const { user } = useSecureAuth();

  return useQuery({
    queryKey: dashboardKeys.paidCreditBalance(user?.id ?? ""),
    queryFn: () => fetchPaidCreditBalance(user!.id),
    enabled: !!user,
  });
}

export function useInvalidateDashboard() {
  const queryClient = useQueryClient();
  const { user } = useSecureAuth();

  return () => {
    if (!user) return;
    void queryClient.invalidateQueries({
      queryKey: dashboardKeys.creditBalance(user.id),
    });
    void queryClient.invalidateQueries({
      queryKey: dashboardKeys.paidCreditBalance(user.id),
    });
    void queryClient.invalidateQueries({
      queryKey: dashboardKeys.orders(user.id),
    });
    void queryClient.invalidateQueries({
      queryKey: dashboardKeys.transactions(user.id),
    });
  };
}
